"use strict";
/// <reference path="irep.js"/>

IREP.salespursuit = (function () {
    var init = function () {
        $(".playButton").attr("onclick", "window.open ('https://retailedge.intel.com/games/salespursuit/?level=0&uid=' + IREP.options.user.currentUID + '&cultureCode=' + IREP.options.user.cultureCode, '_self')");

        $(".playButton").hover(function () {
            $(this).css({ "cursor": "pointer" });
        });
    };
    return {
        init: init
    };
})();
